import { collateErrors as collatePasswordErros } from '@ynap/password-input'

export default function collateErrors(values, props, json) {
    let errors = {}
    const { messages, change } = props
    const passwordErrors = collatePasswordErros(values, props, json)
    const consentFieldName = 'externalConsentsProvided'

    change(consentFieldName, undefined)

    if (json && json.errors) {
        json.errors.forEach(({ errorKey, errorParameters }) => {
            switch (errorKey) {
                case '_ERR_MISSING_PARMS':
                    errors[errorParameters.split(',')[0]] = messages.errors.required({
                        field: errorParameters.split(',')[0],
                    })
                    break
                case '_ERR_VALUE_FOR_PARM_NOT_SUPPORTED':
                    errors[errorParameters.split(',')[0]] = messages.errors.required({
                        field: errorParameters.split(',')[0],
                    })
                    break
                case 'ERR_EXPIRED_VALIDATION_CODE':
                    errors._error = messages.errors.expiredValidationCode()
                    break
                case 'ERR_INVALID_VALIDATION_CODE':
                    errors._error = messages.errors.invalidValidationCode()
                    break
                case 'ERR_TOS_CONSENT_OLD_DATE_ACCEPTANCE_FOR_USER':
                case 'ERR_CONSENT_NOT_ACCEPTED':
                    change(consentFieldName, false)
                    break
            }
        })
    }

    const _error =
        !Object.keys(errors).length && !Object.keys(passwordErrors).length ? messages.errors.global() : undefined

    return { _error, ...errors, ...passwordErrors }
}
